const baseURL = 'https://marial.mundonet.co/';

export default baseURL;
